import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { AccountBalanceWallet } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface BankAccountsFallbackProps {
  moduleName?: string;
}

const BankAccountsPage: React.FC<BankAccountsFallbackProps> = ({ moduleName }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <AccountBalanceWallet sx={{ fontSize: 80, color: 'primary.main', mb: 3 }} />
      <Typography variant="h4" component="h1" gutterBottom>
        {t('sidebar.bankAccounts')}
      </Typography>
      <Alert severity="info" sx={{ mt: 2, maxWidth: 600 }}>
        <Typography variant="body1">
          Модуль банковских счетов пока недоступен. {moduleName ? `(${moduleName})` : ''}
        </Typography>
      </Alert>
    </Box>
  );
};

export default BankAccountsPage;

